import { api } from './client';

export interface AnalysisHistoryItem {
    id: number;
    symbol: string;
    interval: string;
    direction: 'long' | 'short' | 'wait';
    confidence: number;
    summary: string;
    ai_provider: string;
    trade: {
        entry: number | null;
        sl: number | null;
        tp1: number | null;
        tp2: number | null;
        leverage: number | null;
        size: number | null;
        risk_pct: number | null;
    } | null;
    created_at: string;
}

export interface AnalysisStats {
    total: number;
    by_direction: Record<string, number>;
    by_symbol: Record<string, number>;
    avg_confidence: number;
}

export async function fetchHistory(limit = 50, symbol?: string): Promise<AnalysisHistoryItem[]> {
    const params = new URLSearchParams({ limit: String(limit) });
    if (symbol) params.set('symbol', symbol);
    return api.get<AnalysisHistoryItem[]>(`/analyses/history?${params}`);
}

export async function fetchStats(): Promise<AnalysisStats> {
    return api.get<AnalysisStats>('/analyses/stats');
}
